
import { supabase } from "@/integrations/supabase/client";

export interface PrayerRequest {
  id: number;
  title: string;
  content: string;
  user_id: string;
  created_at: string;
  is_anonymous: boolean;
}

export async function fetchPrayerRequestsByChurchCode(churchCode: string): Promise<PrayerRequest[]> {
  try {
    const { data: bracelets, error: braceletError } = await supabase
      .from("bracelets")
      .select("registered_user_id")
      .eq("church_code", churchCode);
      
    if (braceletError) throw braceletError;
    
    const userIds = bracelets
      ?.filter(b => b.registered_user_id)
      .map(b => b.registered_user_id) || [];
      
    if (userIds.length === 0) {
      return [];
    }
    
    const { data, error } = await supabase
      .from("prayer_requests")
      .select("*")
      .in("user_id", userIds)
      .order("created_at", { ascending: false })
      .limit(5);
      
    if (error) throw error;
    
    return data || [];
  } catch (error: any) {
    console.error("Error fetching prayer requests:", error);
    return [];
  }
}
